import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/appUtitlity';
import { md5 } from 'src/md5';

@Component({
  selector: 'app-supplierchangerequest',
  templateUrl: './supplierchangerequest.component.html',
  styleUrls: ['./supplierchangerequest.component.scss']
})

export class SupplierchangerequestComponent implements OnInit {
  supplierId: any;

  constructor(private _apiService: ApiServiceService, private router : Router , private activate: ActivatedRoute, private route: Router, public _utility: AppUtility) { }
  errorMessage: string = ''
  errorMessageCheck: string = ''
  userArray: any;
  invalidEmail: boolean = false;
  submitButton: string = 'Submit'
  imageUploadShowHide: boolean = false;

  //formGroup
  userRegisterFormControl = new FormGroup({
    changeRequest: new FormControl('', [Validators.required])
  })


  ngOnInit(): void {
    this.supplierId = this._utility.getLocalStorageDetails().supplierId;
    console.log(this.supplierId);
    this.getChangeRequestDetails();
    // this.getChangeRequest();
  }

  supplierList : any;

  breadcrumb = [
    {
      title: 'Raise Request',
      subTitle: 'Dashboard'
    }
  ]

  // getChangeRequest(){
  //   let object = {
  //     Cond3 : this.supplierId,
  //     Mode : 'SupplieRaiseRequest'
  //   }
  //   this._apiService.dropdowndata('',object).then((res: any) => {
  //     console.log(res);
  //     this.changeRequestData = res.returnValue;
  //   })
  // }

  changeRequestData : any;

  ChangeRequest: any = [];
  async getChangeRequestDetails() {
    this._utility.loader(true);

    let object = {
      Cond3 : this.supplierId,
      Mode : 'CRChangeList'
    }

    let object1 = {
      loginId : this._utility.getLocalStorageDetails()?.loginId,
      roleName : 'Supplier'
    }

    await this._apiService.profile(object1).then(async (resp:any)=>{
      console.log(resp);
      if(resp.success){
        if(resp.returnValue[0].isApproved != 'Rework' && resp.returnValue[0].isApproved != 'Reworked but not Reviewed'){
          await this._apiService.dropdowndata('' , object).then((res: any) => {
            if(res.success){
                this.ChangeRequest = res.returnValue;
            }
          })
        }

        else{
          this.showChangeList = 'Rework'
        }
      }
    })

    if(this.ChangeRequest.length > 0){
      if(this.ChangeRequest[0].approved){
        this.showChangeList = 'Applied';
      }
      else{
        this.showChangeList = 'List';
      }
    }


    this._utility.loader(false);
  }

  showChangeList : string = 'List';
  submitRequest() {
    if(this.selectedRequest.length > 0){
      let supplierId = this._utility.getLocalStorageDetails()?.supplierId;
      this.selectedRequest.forEach((res:any)=>{
        res.supplierId = supplierId,
        res.CRChangeId = res.id,
        res.name = res.value
      })
      let object : any = {};
      object['raiseRequestDetails'] = this.selectedRequest;
      object['supplierId'] = this.selectedRequest[0].supplierId;
      this._apiService.supplierRaiseRequest(object).then((res:any)=>{
        if(res.success){
          this._apiService.showMessage(res.message , 'success');
          this.ChangeRequest = [];
          this.getChangeRequestDetails();
          this.router.navigateByUrl('/supplierMaster')
        }

        else{
          this._apiService.showMessage(res.message , 'error');
        }
      })
    }

    else{
      this._apiService.showMessage('Please Select Atleast one Request' , 'error');
    }
  }

  selectedRequest: any = [];
  request(event, data, index) {
    if (event.target.checked) {
      this.selectedRequest.push(data);
    }

    else {
      let i = this.selectedRequest.indexOf(data);
      this.selectedRequest.splice(i, 1);
    }


    console.log(this.selectedRequest);
  }
}
